module.exports = __webpack_public_path__ + "img/lupins_chocolate.e3813b7c.jpg";